var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0996 0.8C10.0996 0.358172 10.4578 0 10.8996 0L14.0996 0C14.7361 0 15.3466 0.252856 15.7967 0.702944C16.2468 1.15303 16.4996 1.76348 16.4996 2.4V13.6C16.4996 14.2365 16.2468 14.847 15.7967 15.2971C15.3466 15.7471 14.7361 16 14.0996 16H10.8996C10.4578 16 10.0996 15.6418 10.0996 15.2C10.0996 14.7582 10.4578 14.4 10.8996 14.4H14.0996C14.3118 14.4 14.5153 14.3157 14.6653 14.1657C14.8153 14.0157 14.8996 13.8122 14.8996 13.6L14.8996 2.4C14.8996 2.18783 14.8153 1.98434 14.6653 1.83431C14.5153 1.68429 14.3118 1.6 14.0996 1.6L10.8996 1.6C10.4578 1.6 10.0996 1.24183 10.0996 0.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33392 3.43427C6.64635 3.12185 7.15288 3.12185 7.4653 3.43427L11.4653 7.43427C11.7777 7.74668 11.7777 8.25322 11.4653 8.56564L7.4653 12.5656C7.15288 12.8781 6.64635 12.8781 6.33392 12.5656C6.0215 12.2532 6.0215 11.7467 6.33392 11.4343L9.76825 7.99995L6.33392 4.56564C6.0215 4.25322 6.0215 3.74669 6.33392 3.43427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7.99995C0.5 7.55812 0.858174 7.19995 1.3 7.19995L10.9 7.19995C11.3419 7.19995 11.7 7.55812 11.7 7.99995C11.7 8.44178 11.3419 8.79995 10.9 8.79995L1.3 8.79995C0.858174 8.79995 0.5 8.44178 0.5 7.99995Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.eb256aa5.svg";
export { ForwardRef as ReactComponent };